import { useDataContext } from "./DataProvider";
import { PhoneCallIcon } from "./icons/PhoneCallIcon";
import { ThirtySecClockIcon } from "./icons/ThirtySecClockIcon";

export const QuoteCallout = () => {
	const { companyInfo } = useDataContext();
	const { companyName, phoneNumber } = companyInfo;
	if (!phoneNumber) return null;

	return (
		<a href={`tel:${phoneNumber}`}>
			<div className="tw:relative tw:flex tw:h-full tw:justify-start tw:rounded-t-2xl tw:bg-[#eff7f6] tw:py-2 tw:pl-2 tw:sm:justify-center tw:sm:pl-0 tw:md:rounded-t-[32px] tw:md:rounded-b-[32px] tw:md:py-4">
				<PhoneCallIcon className="tw:mt-0 tw:ml-0 tw:self-start tw:text-[2.5rem] tw:text-[#359492] tw:sm:mt-3 tw:sm:ml-1 tw:md:mt-0 tw:md:text-[3.5rem]" />
				<div className="tw:flex tw:w-3/4 tw:flex-col tw:pr-2 tw:pl-2 tw:md:pl-4">
					<p className="tw:mb-2 tw:w-full tw:text-base tw:leading-5 tw:tracking-[-0.24px] tw:md:text-2xl tw:md:leading-[1.75rem]">
						Need a quote in the next 30 seconds?
					</p>
					<p className="tw:text-base tw:leading-5 tw:font-semibold tw:tracking-[-0.24px] tw:md:text-2xl tw:md:leading-[1.75rem]">
						Call {companyName}
					</p>
					<p className="tw:hide-in-percy tw:mt-2 tw:text-3xl tw:leading-8 tw:font-bold tw:tracking-[-1.6px] tw:text-[#359492] tw:md:text-[40px] tw:md:leading-10">
						{phoneNumber}
					</p>
				</div>
				<ThirtySecClockIcon className="tw:absolute tw:-top-6 tw:-right-6 tw:h-[78px] tw:w-[78px] tw:sm:static tw:sm:h-[104px] tw:sm:w-[104px]" />
			</div>
		</a>
	);
};
